"use client";
import { Box } from "@mui/material";
import Masonry from "react-responsive-masonry";

import { MoreButton } from "./MoreButton";
import LabelWithIcon from "../../../../component/LabelWithIcon";
import { useStore, observer } from "../../../../service/mobx";

function TrendingMasonry({
  spacing = 1,
  trending,
  Card,
  label,
  Icon,
  cta,
  url,
  count,
  disabled,
  prefetch,
  entityName = "paper",
  columns = { compact: 1, medium: 2, expanded: 1, large: 2, extraLarge: 3 }
}) {
  const { device } = useStore();
  const columnsCount = columns[device.size] || 2;

  return (
    <Box pb={2}>
      <LabelWithIcon Icon={Icon} label={label} />
      <Masonry gutter={`${8 * spacing}px`} columnsCount={columnsCount}>
        {trending.map(entity => (
          <Card
            key={entity.id}
            prefetch={prefetch}
            disabled={disabled}
            {...{ [entityName]: entity }}
          />
        ))}
        {disabled ? null : (
          <MoreButton count={count} url={url} text={cta} entity={entityName} />
        )}
      </Masonry>
    </Box>
  );
}

export default observer(TrendingMasonry);
